(function () {
	'use strict';
	angular.module('app.setup')
		.controller('writeBackAuditLog', writeBackAuditLog);

	writeBackAuditLog.$inject = ['$scope', 'pageTimingService'];

	function writeBackAuditLog($scope, pageTimingService) {
		var vm = this;
		var timingCalled = false;

		vm.useReactReport = true;
		vm.reportName = 'Write back audit log';

		var userTimingListener = $scope.$on('showRowsCalled', function () {
			if (!timingCalled) {
				pageTimingService.submitUserTiming('Write back audit log');
				timingCalled = true;
			}
		});
		$scope.$on('$destroy', function () {
			userTimingListener();
		});
	}
})();
